import type { BiInjectedProps as InjectedBiLoggerProps } from '../bi';
import { WithBi } from '../bi';

export const withBiLogger: any = (
  component: React.ComponentType<InjectedBiLoggerProps>,
) => WithBi(component);
